import React from 'react';
import { AnalyticsCardWrapper } from '../../components/AnalyticsCardWrapper/AnalyticsCardWrapper';
import { useAverageOrderValueReportCard, useConversionRateReportCard, usePaymentMethodUsedReportCard, useSalesByCountryReportCard, useSalesBySourceReportCard, useSessionsBySourceReportCard, useVisitorsReportCard, } from '../../hooks/reportCards';
export const ShopAnalytics = () => {
    const averageOrderValueReportCard = useAverageOrderValueReportCard();
    const salesByCountryReportCard = useSalesByCountryReportCard();
    const salesByTrafficSourceReportCard = useSalesBySourceReportCard({
        source: 'traffic_source',
    });
    const salesBySocialPlatformReportCard = useSalesBySourceReportCard({
        source: 'social_platform',
    });
    const sessionsByTrafficSourceReportCard = useSessionsBySourceReportCard({
        source: 'traffic_source',
    });
    const sessionsBySocialPlatformReportCard = useSessionsBySourceReportCard({
        source: 'social_platform',
    });
    const visitorsReportCard = useVisitorsReportCard();
    const paymentMethodUsedReportCard = usePaymentMethodUsedReportCard();
    const conversionRatesReportCard = useConversionRateReportCard();
    return (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsCardWrapper, { ...conversionRatesReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...visitorsReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...averageOrderValueReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...salesByCountryReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...paymentMethodUsedReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...salesByTrafficSourceReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...sessionsByTrafficSourceReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...salesBySocialPlatformReportCard }),
        React.createElement(AnalyticsCardWrapper, { ...sessionsBySocialPlatformReportCard })));
};
